import React from "react";

import { useTranslation } from "utils";

import { Icon, Typography } from "components";

export const PasswordStrengthPopup = ({ currentPasswordStrength }) => {
  const { t } = useTranslation(["signinup"]);

  const PasswordStrengthEntry = ({ checked, text }) => (
    <div className="icon-row white-text margin-top-50 margin-bottom-0">
      <Icon iconName={checked ? "tabler/circle-check" : "tabler/circle"} className="icon inline normal" />
      <Typography variant="paragraph-m" color="white">
        {text}
      </Typography>
    </div>
  );

  return (
    <>
      <Typography variant="h5" color="white">
        {t("password.tips.criteria")}
      </Typography>
      {currentPasswordStrength.password !== currentPasswordStrength.checkPassword || currentPasswordStrength.password === "" ? (
        <PasswordStrengthEntry text={t("password.tips.match")} />
      ) : (
        <PasswordStrengthEntry checked text={t("password.tips.match")} />
      )}
      {currentPasswordStrength.length < 6 ? (
        <PasswordStrengthEntry text={t("password.tips.length")} />
      ) : (
        <PasswordStrengthEntry checked text={t("password.tips.length")} />
      )}
      <Typography variant="h5" color="white" className="margin-top-100">
        {t("password.tips.criteria")}
      </Typography>
      {!currentPasswordStrength.lowercase ? (
        currentPasswordStrength.strength < 1 && <PasswordStrengthEntry text={t("password.tips.lowercase")} />
      ) : (
        <PasswordStrengthEntry checked text={t("password.tips.lowercase")} />
      )}
      {!currentPasswordStrength.uppercase ? (
        currentPasswordStrength.strength < 1 && <PasswordStrengthEntry text={t("password.tips.uppercase")} />
      ) : (
        <PasswordStrengthEntry checked text={t("password.tips.uppercase")} />
      )}
      {!currentPasswordStrength.number ? (
        currentPasswordStrength.strength < 1 && <PasswordStrengthEntry text={t("password.tips.number")} />
      ) : (
        <PasswordStrengthEntry checked text={t("password.tips.number")} />
      )}
      {!currentPasswordStrength.symbol ? (
        currentPasswordStrength.strength < 1 && <PasswordStrengthEntry text={t("password.tips.symbol")} />
      ) : (
        <PasswordStrengthEntry checked text={t("password.tips.symbol")} />
      )}
    </>
  );
};
